module.exports = __webpack_public_path__ + "images/category_lp/bike/new/store_images/4_0b3889880513e541c150e560e94c4c13.png";